import React from "react";
import { withStyles } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import DriverPreferencesGrid from "./Grid";
import DriverPreferencesForm from "./Form";
import appConstants from "../../../../../appConstants";
import DeleteDriverPreferences from "./DeleteDriverPreferences";

const styles = (theme) => ({
  moduleContainer: {
    padding: 32,
  },
  paperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 100,
    backgroundColor: theme.ModalBGColor,
  },
});
class DriverPreferences extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      driverData: null,
      errorMessage: appConstants.GRID_STATUS.LOADING,
      selectedDriverPreferences: [],
      isDriverPreferenceFromOpen: false,
      driverPreferenceInfo: null,
      driverPreferencesData: null,
    };
  }

  componentDidMount() {
    this.getDriverPreferenceData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id) {
      this.getDriverPreferenceData();
    }
  }

  getDriverPreferenceData = () => {
    const terminalId = this.props.userData.userProfile.terminal.id;
    getDataWithQueryString(
      "GetGroupedDriverPreferences",
      `terminalId=${terminalId}`
    ).then(
      (response) => {
        if (response.status === 200) {
          this.setState({
              driverData: response.data,
              errorMessage: appConstants.GRID_STATUS.SUCCESS
            });
          } else {
            this.handleError();
          }
        },
        (error) => {
          this.handleError();
        }
      );
  };

  handleError = () => {
    this.setState({
      driverData: [],
      errorMessage: appConstants.GRID_STATUS.ERROR
    });
  };

  selectDriverPreferencesOnGrid = (selectedDriverPreferences) => {
    this.setState({ selectedDriverPreferences });
  };

  selectDriverPreferenceOnForm = (
    selectedDriverPreferences,
    driverPreferenceInfo
  ) => {
    this.setState({
      driverPreferenceInfo,
      selectedDriverPreferences,
    });
  };

  onDriverPreferenceFormOpen = (
    selectedDriverPreferences,
    driverPreferenceInfo
  ) => {
    this.setState({
      isDriverPreferenceFromOpen: true,
      driverPreferenceInfo,
      selectedDriverPreferences,
    });
  };

  onDriverPreferenceFromClose = () => {
    this.setState({
      isDriverPreferenceFromOpen: false,
      driverPreferenceInfo: null,
    });
  };

  onDeleteDriverPreference = (driverPreferencesData) => {
    this.setState({
      driverPreferencesData,
    });
  };

  onCancelDriverPreferenceDeletion = () => {
    this.setState({
      driverPreferencesData: null,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      driverData,
      driverPreferenceInfo,
      isDriverPreferenceFromOpen,
      selectedDriverPreferences,
      driverPreferencesData,
    } = this.state;

    return (
      <div className={classes.moduleContainer}>
        <DriverPreferencesGrid
          onDriverPreferenceFormOpen={this.onDriverPreferenceFormOpen}
          selectedDriverPreferences={selectedDriverPreferences}
          isDriverPreferenceFromOpen={isDriverPreferenceFromOpen}
          onDeleteDriverPreference={this.onDeleteDriverPreference}
          driverData={driverData}
          errorMessage={this.state.errorMessage}
          selectDriverPreferencesOnGrid={this.selectDriverPreferencesOnGrid}
        />
        {isDriverPreferenceFromOpen ? (
          <DriverPreferencesForm
            open={isDriverPreferenceFromOpen}
            driverPreferenceInfo={driverPreferenceInfo}
            onClose={this.onDriverPreferenceFromClose}
            drawerClasses={{
              paper: classes.paperAnchor,
            }}
            getDriverPreferenceData={this.getDriverPreferenceData}
            selectDriverPreferenceOnForm={this.selectDriverPreferenceOnForm}
            variant="persistent"
            driverData={driverData}
            userData={this.props.userData}
          />
        ) : null}
        {driverPreferencesData && (
          <DeleteDriverPreferences
            onCancel={this.onCancelDriverPreferenceDeletion}
            getDriverPreferenceData={this.getDriverPreferenceData}
            selectedDriverPreference={driverPreferencesData}
            userData={this.props.userData}
          />
        )}
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withUserProfile,
  withSnackbar
)(DriverPreferences);
